<template>
<div>
    <!-- <div @click.stop="show">11222</div> -->
    <me-field
        readonly
        clickable
        name="picker"
        label="选择器"
        placeholder="点击选择城市"
        @click="showPop = true"
        />
    <me-popup v-model="showPop" position="bottom">
        <me-picker
            show-toolbar
            v-bind="$attrs"
            @cancel="showPop = false"
        />
    </me-popup>
</div>
</template>
<script>
export default {
    data() {
        return {
            showPop: false,
        }
    },
    props: {

    },
    created() {
    },
    methods: {
        show() {
            this.showPop = true
        },
    },
}
</script>
